import * as swcHelpers from '@swc/helpers';
import React__default from 'react';
import classnames from 'classnames';
import { Select } from '@grandvisionhq/forms';
import { PrescriptionValueUtils } from '@grandvisionhq/utils';
import { isPrescriptionValue } from '../../../../state/types.js';
import { usePrescriptionFormInput } from '../../context/PrescriptionFormInputContext.js';

const getOptions = (values, prescriptionAttribute)=>{
    const formatter = PrescriptionValueUtils.getFormatter(prescriptionAttribute);
    return Array.from(values).reduce((acc, value)=>{
        const formattedValue = formatter(value);
        if (formattedValue) {
            return swcHelpers.objectSpread({}, acc, {
                [formattedValue]: value
            });
        } else {
            console.error(`Error formatting prescription value ${value} for attribute: ${prescriptionAttribute}`);
            return acc;
        }
    }, {});
};
const PrescriptionFormInputSelect = ()=>{
    const { name , selectId , labelId , parentId , selectName , errorMessageId , isValid , isFirstItem , isLastItem , values , value , onChange ,  } = usePrescriptionFormInput();
    const options = React__default.useMemo(()=>getOptions(values, name)
    , [
        values,
        name
    ]);
    const sortOptions = React__default.useCallback((a, b)=>Number(a) - Number(b)
    , []);
    var ref;
    const formattedValue = (ref = PrescriptionValueUtils.formatPrescriptionValue(name, value)) !== null && ref !== void 0 ? ref : '';
    const isInvalid = isValid === false;
    const valueAsString = React__default.useMemo(()=>({
            value: isPrescriptionValue(value) && values.has(value) ? formattedValue : ''
        })
    , [
        values,
        value,
        formattedValue
    ]);
    const handleChange = React__default.useCallback((newValue)=>{
        onChange(name, newValue);
    }, [
        onChange,
        name
    ]);
    return /*#__PURE__*/ React__default.createElement(Select, {
        id: selectId,
        "aria-labelledby": `${labelId} ${parentId}`,
        "aria-describedby": errorMessageId,
        "aria-invalid": isInvalid,
        className: classnames('prescription-form-input-select', {
            'prescription-form-input-select--first': isFirstItem,
            'prescription-form-input-select--last': isLastItem
        }),
        options: options,
        sortOptionsBy: sortOptions,
        initialState: valueAsString,
        onChange: handleChange,
        name: selectName,
        "data-t": selectName,
        placeholder: "---"
    });
};

export { PrescriptionFormInputSelect };
//# sourceMappingURL=PrescriptionFormInputSelect.js.map
